var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ylContactHire"}},[(_vm.isMobileScreen)?_c('ylContactHireMobile',{attrs:{"list":_vm.list}}):_c('ylContactHirePC',{attrs:{"list":_vm.list}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }